import React from "react";
import { connect } from "react-redux";
import {
  fetchSummaryPageFields,
  sendEmail,
  toggleEmailModal,
  setBuyURL,
  initNecklacesAndMemories,
} from "../../redux/actions/";
import { Header, SelectedNecklaces } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_SummaryPage.scss";
import { withRouter } from "react-router-dom";
import EmailModal from "../../components/EmailModal/EmailModal";
import Necklace from "../../components/Necklace/Necklace";
import PriceDisplayNecklace from "../../components/PriceDisplay/PriceDisplayNecklace";
import queryString from "query-string";
import GalleryNecklace from "../../components/Gallery/GalleryNecklace";
const SHOPIFY_URL = process.env.REACT_APP_SHOPIFY_URL;

class SummaryPageNecklace extends React.Component {
  renderWishListBuySection = () => {
    const { wishListButtonText, buyButtonText } = this.props;
    return (
      <div className="wish-buy-section">
        <button
          className="squared-button light-petrol"
          onClick={() => this.onWishListButtonPress()}
        >
          {wishListButtonText}
        </button>
        <button
          className="squared-button copper"
          onClick={() => this.onBuyButtonPress()}
        >
          {buyButtonText}
        </button>
      </div>
    );
  };

  onBuyButtonPress = () => {
    const buyURL = this.generateBuyLink();
    window.location.href = buyURL;
  };

  generateBuyLink = () => {
    const {
      activeMemories,
      activeNecklace,
      history,
      calculateNecklacePrice,
    } = this.props;
    let buyURL = `${SHOPIFY_URL}/cart/`;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    let necklaceMaterial = "yellow-gold";
    if (queryParams) {
      necklaceMaterial = queryParams["necklace-material"];
    }
    if (activeNecklace) {
      // First add necklace to the buyURL:
      if (calculateNecklacePrice) {
        // Calculate necklace price is true, so add necklace to buyURL:
        switch (necklaceMaterial) {
          default:
            buyURL = activeNecklace.fields.shopifyProductYellowGold
              ? buyURL + `${activeNecklace.fields.shopifyProductYellowGold}:1`
              : buyURL;
            break;
          case "rose-gold":
            buyURL = activeNecklace.fields.shopifyProductRoseGold
              ? buyURL + `${activeNecklace.fields.shopifyProductRoseGold}:1`
              : buyURL;
            break;
          case "white-gold":
            buyURL = activeNecklace.fields.shopifyProductWhiteGold
              ? buyURL + `${activeNecklace.fields.shopifyProductWhiteGold}:1`
              : buyURL;
            break;
        }
      }
    }
    const memoryProductIDs = [];
    if (activeMemories && activeMemories.length) {
      for (let i = 0; i < activeMemories.length; i++) {
        let productID = null;
        switch (activeMemories[i].material) {
          default:
            productID = activeMemories[i].memory.fields.shopifyProductYellowGold
              ? activeMemories[i].memory.fields.shopifyProductYellowGold
              : null;
            break;
          case "rose-gold":
            productID = activeMemories[i].memory.fields.shopifyProductRoseGold
              ? activeMemories[i].memory.fields.shopifyProductRoseGold
              : null;
            break;
          case "white-gold":
            productID = activeMemories[i].memory.fields.shopifyProductWhiteGold
              ? activeMemories[i].memory.fields.shopifyProductWhiteGold
              : null;
            break;
        }
        if (productID) {
          let isDuplicate = false;
          for (let y = 0; y < memoryProductIDs.length; y++) {
            if (memoryProductIDs[y].productID === productID) {
              memoryProductIDs[y].quantity++;
              isDuplicate = true;
            }
          }
          if (!isDuplicate) {
            memoryProductIDs.push({ productID: productID, quantity: 1 });
          }
        }
      }
    }
    if (memoryProductIDs && memoryProductIDs.length) {
      for (let i = 0; i < memoryProductIDs.length; i++) {
        if (!calculateNecklacePrice && i === 0) {
          buyURL =
            buyURL +
            `${memoryProductIDs[i].productID}:${memoryProductIDs[i].quantity}`;
        } else {
          buyURL =
            buyURL +
            `,${memoryProductIDs[i].productID}:${memoryProductIDs[i].quantity}`;
        }
      }
    }
    this.props.setBuyURL(buyURL);

    return buyURL;
  };

  onWishListButtonPress = () => {
    console.log("wish list button pressed");
  };

  onShareButtonPress = () => {
    this.generateBuyLink();
    this.props.toggleEmailModal();
  };

  render() {
    const {
      pageTitleText,
      backButtonText,
      priceText,
      redoButtonText,
      shareButtonText,
      wishListButtonText,
      activeNecklace,
      activeMemories,
      selectedItemsText,
    } = this.props;

    return (
      <div className="summary-page summary-page-necklace ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <div className="selections">
          <Necklace />
        </div>
        <GalleryNecklace />
        <div className="configurator-info">
          <SelectedNecklaces
            title={selectedItemsText}
            necklace={activeNecklace}
            memories={activeMemories}
          />
          <PriceDisplayNecklace title={priceText} />
        </div>
        {this.renderWishListBuySection()}
        <Footer
          backButtonText={backButtonText}
          redoButtonText={redoButtonText}
          onShareButtonPress={() => this.onShareButtonPress()}
          shareButtonText={shareButtonText}
          wishListButtonText={wishListButtonText}
        />
        <EmailModal
          titleText="Jaa sormus"
          onSendButtonPress={() => this.sendEmail()}
        />
      </div>
    );
  }
}

const mapStateToProps = ({
  summaryPage,
  necklace,
  configuratorPageNecklace,
}) => {
  const {
    pageTitleText,
    backButtonText,
    buyButtonText,
    priceText,
    redoButtonText,
    shareButtonText,
    wishListButtonText,
  } = summaryPage;
  const { selectedItemsText } = configuratorPageNecklace;
  const { activeNecklace, activeMemories, calculateNecklacePrice } = necklace;

  return {
    pageTitleText,
    backButtonText,
    buyButtonText,
    priceText,
    redoButtonText,
    shareButtonText,
    wishListButtonText,
    activeNecklace,
    activeMemories,
    selectedItemsText,
    calculateNecklacePrice,
  };
};

export default connect(mapStateToProps, {
  fetchSummaryPageFields,
  sendEmail,
  toggleEmailModal,
  setBuyURL,
  initNecklacesAndMemories,
})(withRouter(SummaryPageNecklace));
